// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'

export class Loading extends Component {
    render() {
        if (this.props.embedType === "tbody") {
            return (
                <tr className="loading-panel">
                    <td>
                        <Col smOffset={4} sm={3} lg={3}>
                            <img src="/assets/images/Spinner-1s-200px.gif" alt="Loading" />
                        </Col>
                    </td>
                </tr>
            )
        } else {
            return (
                <Row className="loading-panel">
                    <Col smOffset={4} sm={1} lg={1}>
                        <img src="/assets/images/Spinner-1s-200px.gif" alt="Loading" />
                    </Col>
                </Row>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/loading.js